import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ReadinessCell } from './readiness-rules';

/**
 * One readiness cell (#262): what the page has, marked when it's missing; a missing one that a tab fixes is a button
 * that opens it. Presentational.
 */
@Component({
  selector: 'app-readiness-cell',
  template: `
    <button
      *ngIf="cell.ok === false && fixable; else plain"
      type="button"
      class="gap"
      (click)="open.emit()"
      [attr.aria-label]="'Fix: ' + cell.text"
    >
      <i class="pi pi-exclamation-circle" aria-hidden="true"></i> {{ cell.text }}
    </button>
    <ng-template #plain>
      <span [class.missing]="cell.ok === false" [class.na]="cell.ok === null"
        ><i *ngIf="cell.ok" class="pi pi-check ok" aria-hidden="true"></i> {{ cell.text }}</span
      >
    </ng-template>
  `,
  styleUrls: ['./readiness-cell.component.scss'],
})
export class ReadinessCellComponent {
  @Input() cell!: ReadinessCell;
  /** A tab fixes this gap. */
  @Input() fixable = false;
  @Output() open = new EventEmitter<void>();
}
